export default __webpack_public_path__ + "static/media/Distribution of Attacks Among Healthcare.831f2e2d.png";